/*
 * Public API Surface of messages
 */

export * from './lib/routes/messages.routes';

export * from './lib/messages-config';

export * from './lib/components/box-messages/box-messages';